import { render, staticRenderFns } from "./activity-collectCards-record.vue?vue&type=template&id=3990e7b7&scoped=true&"
import script from "./activity-collectCards-record.vue?vue&type=script&lang=js&"
export * from "./activity-collectCards-record.vue?vue&type=script&lang=js&"
import style0 from "./activity-collectCards-record.vue?vue&type=style&index=0&id=3990e7b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990e7b7",
  null
  
)

export default component.exports